import React, { useState, useMemo, Fragment, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector, useDispatch } from 'react-redux';
import { Button, SuccessBlock } from 'components/Ui';
import { ValidatorForm } from 'react-material-ui-form-validator';
import * as drawerActions from 'containers/DrawerManager/actions';
import * as paymentActions from 'containers/PrimoProfile/actions';
import StatementSettings from 'containers/PrimoProfile/StatementSettings/form';
import { selectUserEmail } from 'containers/Authentication/selectors';
import {
  selectIsStatementProcessing,
  selectStatementData,
} from 'containers/PrimoProfile/selectors';
import PropTypes from 'prop-types';
import {
  selectBankAccounts,
  selectCreditCards,
  selectCurrentPaymentMethod,
  selectIsBankAccountFetching,
  selectIsCardsFetching,
  selectStatementSettings,
  selectIsInvoiceSuccessful,
} from '../../selectors';
import styles from './styles.scss';

const InvoiceForm = ({ email, onClose, isInvoiceSuccessful }) => {
  const dispatch = useDispatch();
  const isProcessing = useSelector(selectIsStatementProcessing());
  const statementData = useSelector(selectStatementData());
  const [values, changeValues] = useState(statementData);

  useEffect(() => {
    changeValues({
      ...statementData,
      paperlessEnabled: statementData.paperlessEnabled
        ? statementData.paperlessEnabled
        : true,
      email: statementData.email ? statementData.email : [email],
    });
  }, [statementData.paperlessEnabled]);

  const handleSave = () => {
    dispatch(paymentActions.updateStatementSettings(values));
  };

  const handleChange = (name, value) => {
    changeValues({ ...values, [name]: value });
  };

  const isShowFeeMessage = useMemo(
    () => statementData.paperlessEnabled && !values.paperlessEnabled,
    [statementData.paperlessEnabled, values.paperlessEnabled],
  );
  return (
    <Fragment>
      {!isInvoiceSuccessful ? (
        <ValidatorForm onSubmit={handleSave}>
          {isShowFeeMessage}
          <div className={styles.content}>
            <StatementSettings values={values} onChange={handleChange} />
          </div>
          <div className={styles.footer}>
            <div className={styles.buttons}>
              <Button
                color="gray"
                className={styles.button}
                text="Cancel"
                onClick={onClose}
                type="button"
                disabled={isProcessing}
              />
              <Button
                className={styles.button}
                data-tracking="Save eInvoice Preferences"
                text="Save"
                loading={isProcessing}
              />
            </div>
          </div>
        </ValidatorForm>
      ) : (
        <div className={styles.successContainer}>
          <SuccessBlock text="Your changes have been saved." />
        </div>
      )}
    </Fragment>
  );
};

InvoiceForm.propTypes = {
  email: PropTypes.array,
  onClose: PropTypes.func,
  isInvoiceSuccessful: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  creditCards: selectCreditCards(),
  bankAccounts: selectBankAccounts(),
  defaultPaymentMethod: selectCurrentPaymentMethod(),
  statementSettings: selectStatementSettings(),
  isCardsFetching: selectIsCardsFetching(),
  isBankAccountFetching: selectIsBankAccountFetching(),
  isStatementProcessing: selectIsStatementProcessing(),
  email: selectUserEmail(),
  isInvoiceSuccessful: selectIsInvoiceSuccessful(),
});

const mapDispatchToProps = {
  showDrawer: drawerActions.showDrawer,
  updateBankAccount: paymentActions.updateBankAccount,
  updateCreditCard: paymentActions.updateCreditCard,
  showStatementSettings: paymentActions.showStatementSettings,
  updateStatementSettings: paymentActions.updateStatementSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
